import './soporte.scss';
import '../../js/form-init';
import '../../js/form-select';
import '../../js/dropdown-menu';
import '../../js/floating-header';
import '../../js/mobile-tabs';
import '../../js/nav-row';
import '../../js/scroll-animation';
import '../../js/lazy-load';
import '../../js/lazy-load-recaptcha';
import '../../js/lottie';
import '../../js/footer-current-year';
import { scrollTo } from '../../js/scroll-to-contact';

import $ from 'jquery';

$(function () {

  $(window).on('hashchange', initialize);
  $('.empty-section').fadeOut('fast', initialize);
  // initialize();
  function initialize() {
    const tabHash = window.location.hash.split('_')[0];
    switch (tabHash) {
      // Soporte
      default:
        setSoporte();
        break;

      case "#cloud-pros":
        setCloudPros();
        break;
    }
  }

  function scrollToContacto() {
    switch (window.location.hash) {
      case "#contacto":
      case "#contact":
      case "#contacte":
      case "#cloud-pros_contacto":
      case "#cloud-pros_contact":
      case "#cloud-pros_contacte":
        scrollTo($(window.location.hash).offset().top);
        break;
    }
  }

  function setSoporte() {
    $(".soporte-pro-header__content").fadeOut('fast', function () {
      $(".soporte-header__content").fadeIn('fast');
    });
    $(".soporte-pro").fadeOut('fast', function () {
      $(".soporte").fadeIn('fast', scrollToContacto);
    });


    const lang = $('html').attr('lang');

    let href;
    switch (lang) {
      case 'es':
        href = "#contacto"; break;
      case 'en':
        href = "#contact"; break;
      case 'ca':
        href = "#contacte"; break;
    }

    $('.js-header__mobile-tab-contacto').attr('href', href);
  }

  function setCloudPros() {
    $(".soporte-header__content").fadeOut('fast', function () {
      $(".soporte-pro-header__content").fadeIn('fast');
    });

    $(".soporte").fadeOut('fast', function () {
      $(".soporte-pro").fadeIn('fast', scrollToContacto);
    });


    const lang = $('html').attr('lang');

    let href;
    switch (lang) {
      case 'es':
        href = "contacto"; break;
      case 'en':
        href = "contact"; break;
      case 'ca':
        href = "contacte"; break;
    }

    $('.js-header__mobile-tab-contacto').attr('href', `#cloud-pros_${href}`);
  }

});